<script lang="ts" setup>
  import { RouterLink } from "vue-router";
  import { useThemeStore } from "@/stores/theme";
  import defaultLogo from "@/assets/images/logo-placeholder.png";

  const themeStore = useThemeStore();
  const logo = themeStore.logo ?? defaultLogo;
</script>

<template>
  <router-link to="/">
    <img :src="logo" />
  </router-link>
</template>

<style lang="scss" scoped>
  a {
    height: 100%;
    display: flex;
    align-items: center;

    img {
      mix-blend-mode: darken;
      width: 140px;
    }
  }
</style>